import React from 'react';
import PropTypes from 'prop-types';
import { formatPlayer } from '../../lib/format';

const LineupPlayerSelector = ({ players, player, onPlayerSelected }) => {
  const onPlayerSelectedChange = event => {
    const selectValue = event.target.value && parseInt(event.target.value, 10);
    onPlayerSelected(selectValue);
  };

  return (
    <div className="s-game-explorer__lineup-player">
      <select value={player ? player : ''} onChange={onPlayerSelectedChange}>
        <option value={''}>All players</option>
        {players &&
          players.map(player => (
            <option key={player.id} value={player.id}>
              {formatPlayer(player)} ({player.plusMinusPlayer})
            </option>
          ))}
      </select>
    </div>
  );
};

LineupPlayerSelector.propTypes = {
  player: PropTypes.number,
  players: PropTypes.array.isRequired,
  onPlayerSelected: PropTypes.func.isRequired,
};

export default LineupPlayerSelector;
